import Header from "./Header";
import Link from "next/link";
import { ChevronLeft } from "lucide-react";
import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backHref?: string;
  onBack?: () => void;
  children?: ReactNode;
}

export default function PageHeader({ title, subtitle, backHref, onBack, children }: PageHeaderProps) {
  return (
    <>
      <Header />
      <div className="bg-white px-5 pb-4">
        <div className="flex items-center gap-1.5">
          {backHref && (
            <Link
              href={backHref}
              aria-label="Back"
              className="-ml-2 w-8 h-8 flex items-center justify-center rounded-full text-text-dark/55 active:bg-gray-100"
            >
              <ChevronLeft size={20} />
            </Link>
          )}
          {onBack && (
            <button
              onClick={onBack}
              aria-label="Back"
              className="-ml-2 w-8 h-8 flex items-center justify-center rounded-full text-text-dark/55 active:bg-gray-100"
            >
              <ChevronLeft size={20} />
            </button>
          )}
          <h1 className="text-[22px] font-extrabold tracking-[-0.3px] text-text-dark leading-tight">
            {title}
          </h1>
        </div>
        {subtitle && (
          <p className="mt-1.5 text-[13.5px] leading-[1.45] text-text-dark/55">{subtitle}</p>
        )}
        {children}
      </div>
    </>
  );
}
